import styled from "styled-components";

export const FestivalEventLocationWrapper = styled.div`
  padding: 24px 16px 24px;
  color: #121212;

  > .title {
    font-weight: 700;
    font-size: 16px;
    margin-bottom: 12px;
  }

  #map {
    width: 100%;
    height: 129px;
    border-radius: 8px;
  }
`;

export const FestivalEventLocationInfo = styled.div`
  margin-top: 8px;
  display: flex;
  align-items: center;
  gap: 4px;
  justify-content: space-between;
  width: 100%;
`;

export const FestivalEventLocationText = styled.div`
  display: flex;
  gap: 2px;
  flex-direction: column;

  > .name {
    font-weight: 700;
    font-size: 12px;
  }

  > .address {
    font-weight: 500;
    font-size: 12px;
    color: #808080;
  }
`;

export const FestivalEventLocationCopy = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
  font-weight: 700;
  font-size: 12px;
  color: #6436e7;

  > img {
    width: 18px;
    height: 18px;
  }
`;
